// extracted by mini-css-extract-plugin
export default {"root":"_2sqi0","small":"_2rNqS","normal":"_21PA3"};